import script from "./AppSwiperItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwiperItem.vue?vue&type=script&setup=true&lang=js"

import "./AppSwiperItem.vue?vue&type=style&index=0&id=d4de09f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4de09f8"]])

export default __exports__